import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import ArchivedSubcontractorList from "./ArchivedSubcontractorList";

export default function ArchivedSubcontractorsPage() {
  return (
    <DashboardLayout activeTab="subcontractors">
      <ArchivedSubcontractorList />
    </DashboardLayout>
  );
}
